import React from 'react';

const CheckPermission = ({ label, checked, onChange }) => {
  const toggle = () => onChange({ target: { checked: !checked } });

  return (
    <button
      type="button"
      onClick={toggle}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-150 select-none"
      style={checked ? {
        backgroundColor: 'rgba(34,197,94,0.12)',
        border: '1px solid rgba(34,197,94,0.35)',
        color: '#4ADE80',
      } : {
        backgroundColor: 'rgb(var(--fg) / 0.04)',
        border: '1px solid rgb(var(--fg) / 0.08)',
        color: 'rgb(var(--fg-faint))',
      }}
    >
      <span
        className="h-1.5 w-1.5 rounded-full flex-shrink-0"
        style={{ backgroundColor: checked ? '#22C55E' : 'rgb(var(--fg-faint))' }}
      />
      {label}
    </button>
  );
};

export default CheckPermission;
